import { Button } from "@/components/ui";
import { useT } from "@/i18n";
import { settingsSkillsMessages } from "@/i18n/messages/settings-skills";
import { useSettingsNav } from "./settings-navigation";
import { useSkillPage } from "./skill-page-state";
import { SkillUnavailable } from "./skill-page";
import { sectionsFor } from "./work-skill-content";
import { WorkSkillEditor } from "./work-skill-editor";

export function SkillCustomizePage({ skillId }: { skillId: string }) {
  const t = useT(settingsSkillsMessages);
  const nav = useSettingsNav();
  const state = useSkillPage(skillId, "work");
  if (
    state.loading ||
    state.error ||
    !state.detail ||
    !(state.detail.shared || state.detail.metadata.adapts)
  )
    return <SkillUnavailable loading={state.loading} retry={state.retry} />;
  const detail = state.detail;
  // A direct Customize link must not create a duplicate personal version.
  if (state.personal && detail.shared)
    return (
      <div className="px-2">
        <Button
          size="sm"
          variant="secondary"
          data-testid="customize-open-personal"
          onClick={() =>
            nav.open({
              page: "skills-skill",
              args: { skillId: state.personal!.id, kind: "work" },
            })
          }
        >
          {t("openYourVersion")}
        </Button>
      </div>
    );
  return (
    <WorkSkillEditor
      key={detail.id}
      detail={detail}
      steps={sectionsFor(detail).flatMap((section) => section.steps)}
      onCancel={nav.back}
      onSaved={(saved) => {
        if (detail.shared)
          nav.open({
            page: "skills-skill",
            args: {
              skillId: saved.id,
              title: String(saved.metadata.title ?? saved.name),
              kind: "work",
            },
          });
        else state.setDetail(saved);
      }}
    />
  );
}
